<template>
	<div id="top">
		<div class="top_left">
			<div class="top_h1">
				策宇信息医护安全智能管控系统
			</div>
			<div>
				<el-tabs v-model="editableTabsValue" type="card" closable @tab-click="tabTab" @tab-remove="removeTab">
					<el-tab-pane v-for="(item, index) in editableTabs" :key="index" :label="item.title"
						:name="item.name"></el-tab-pane>
				</el-tabs>
			</div>
		</div>
		<div class="top_right">
			<span>您好，{{this_user.userName}}</span>
			<span class="ml10">|</span>
			<el-dropdown trigger="click" @command="handleCommand">
				<span class="el-dropdown-link ml10">{{this_user.deptName}}<i
						class="el-icon-arrow-down el-icon--right"></i></span>
				<el-dropdown-menu slot="dropdown">
					<!--el-dropdown-item command="changePwd" icon="el-icon-edit">更改密码</el-dropdown-item-->
					<el-dropdown-item command="goFrontPage" icon="el-icon-monitor">管理前台</el-dropdown-item>
					<el-dropdown-item command="goOut" icon="el-icon-circle-close">退出登陆</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
		<el-dialog title="修改密码" :visible.sync="changePwdBox" width="400px">
			<el-form label-width="100px">
				<el-form-item label="工号">
					<el-input v-model="pwdForm.empNo" style="width: 200px;" clearable></el-input>
				</el-form-item>
				<el-form-item label="旧密码">
					<el-input v-model="pwdForm.oldPassword" style="width: 200px;" show-password></el-input>
				</el-form-item>
				<el-form-item label="新密码">
					<el-input v-model="pwdForm.newPassword" style="width: 200px;" show-password></el-input>
				</el-form-item>
				<el-form-item label="确认新密码">
					<el-input v-model="check_newPassword" style="width: 200px;" show-password></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="changePwdBox = false">取消</el-button>
				<el-button type="primary" @click="goSave">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		mixins: [require("@/mymixins").default],
		data() {
			return {
				editableTabsValue: '2',
				editableTabs: [],
				tabIndex: 2,
				nowTab: 0,
				tabOnly: true,
				deptName: '',
				userName: '',
				changePwdBox: false,
				check_newPassword: '',
				pwdForm: {
					empNo: '',
					oldPassword: '',
					newPassword: ''
				},
				this_user: {},
				leftDept: []
			}
		},
		created() {
			this.$bus.on('changTab', this.goChangTab);
		},
		watch: {},
		mounted() {
			//console.log(this.userInfo);
			this.pwdForm.empNo = this.userInfo.empNo;
			this.userName = this.userInfo.userName;
			this.deptName = this.userInfo.deptName;
			this.this_user = this.userInfo;
		},
		methods: {
			goSave() {
				if (!this.pwdForm.oldPassword) {
					this.$message.error("请输入旧密码");
					return false;
				}
				if (!this.pwdForm.newPassword) {
					this.$message.error("请输入新密码");
					return false;
				}
				if (this.check_newPassword != this.pwdForm.newPassword) {
					this.$message.error("两次输入密码不一致");
					return false;
				}
				this.post("changePassword", this.pwdForm).then(res => {
					if (res.success == true) {
						this.$message({
							message: '修改成功，请重新登陆',
							type: 'success'
						});
						this.goOut();
					} else {
						this.$message.error(res.detail);
					}
				});
			},
			handleCommand(e) {
				//console.log(e);
				if (e == 'changePwd') {
					this.changePwd();
				} else if (e == 'goOut') {
					this.goOut();
				} else if (e == 'goFrontPage') {
					//console.log(this.userInfo);
					if (this.userInfo.isAdmin) {
						this.$message.error("管理科只能登陆信息管理平台");
					} else {
						this.$router.replace({
							name: "monitor"
						});
					}
				} else {
					this.$emit("goChange", "refresh");
					let data = {};
					if (e != this.this_user.deptAllNo) {
						data.deptNo = e;
					}
					this.post("login/switch", data).then(res => {
						if (res.success == true) {
							let nowDept = this.leftDept.find((x) => x.k == e);
							let newDeptName = this.this_user.deptAllName;
							if (e != this.this_user.deptAllNo) {
								newDeptName = this.this_user.deptAllName + "-" + nowDept.n;
							}
							let tempUserInfo = this.userInfo;
							tempUserInfo.deptName = newDeptName;
							tempUserInfo.deptNo = e;
							this.setUserInfo(tempUserInfo);
							//console.log(this.userInfo);
							this.$emit('hosChange', {
								do: 'reload'
							});
						}
					});
				}
			},
			changePwd() {
				this.changePwdBox = true;
			},
			goOut() {
				this.setUserInfo({
					deptName: "",
					deptNo: "",
					userName: "",
					empNo: "",
					userId: "",
					deptRoleId: "",
					userToken: "",
					userRole: "",
					previledgeList: []
				});
				this.lastUserInfo();
				this.$router.replace({
					name: "login"
				});
			},
			goChangTab(e) {
				//let e = a.ct;
				if (this.tabOnly) {
					if (e != undefined) {
						this.tabOnly = false;
						let find_index = this.editableTabs.findIndex((tab) => tab.url === e.url);
						if (find_index != -1) {
							//console.log(find_index);
							this.tabTab({
								index: find_index
							});
						} else {
							this.addTab(e);
						}
					}
				}

			},
			addTab(targetName) {
				let newTabName = ++this.tabIndex + '';
				this.editableTabs.push({
					title: targetName.txt,
					name: newTabName,
					url: targetName.url,
					//params: targetName.params
				});
				this.nowTab = this.editableTabs.findIndex((item) => item.name == newTabName);
				this.editableTabsValue = newTabName;
				this.tabOnly = true;
			},
			tabTab(e) {
				this.tabOnly = true;
				//console.log(e);
				this.nowTab = e.index;
				this.editableTabsValue = this.editableTabs[this.nowTab].name;
				this.$router.replace({
					name: this.editableTabs[this.nowTab].url
				}).catch(err => err);
			},
			removeTab(targetName) {
				//console.log(this.editableTabs);
				if (this.editableTabs.length == 1) {
					this.$router.replace({
						name: "admin"
					}).catch(err => err);
				}
				let tabs = this.editableTabs;
				let activeName = this.editableTabsValue;
				if (activeName === targetName) {
					tabs.forEach((tab, index) => {
						if (tab.name === targetName) {
							if (tabs[index + 1]) {
								let nextTab = tabs[index + 1];
								activeName = nextTab.name;
								this.$router.replace({
									name: this.editableTabs[index + 1].url
								}).catch(err => err);
							} else if (tabs[index - 1]) {
								let nextTab = tabs[index - 1];
								activeName = nextTab.name;
								this.$router.replace({
									name: this.editableTabs[index - 1].url
								}).catch(err => err);
							}
						}
					});
				}

				this.editableTabsValue = activeName;
				this.editableTabs = tabs.filter(tab => tab.name !== targetName);
			}
		}
	}
</script>

<style lang="scss">
	#top {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		height: 100%;

		.top_left {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			height: 100%;

			.top_h1 {
				color: #ffffff;
				text-shadow: 1px 1px 2px #000099;
				font: 20px "黑体";
				flex: 1;
				display: flex;
				flex-direction: row;
				align-items: center;
			}
		}

		.top_right {
			display: flex;
			flex-direction: row;
			justify-content: flex-end;
			align-items: center;
			padding-right: 10px;

			.ml10 {
				margin-left: 10px;
			}
		}

		.el-tabs__header {
			margin: 0px;
		}

		.el-tabs__item {
			background: #ffffff;
		}
	}
</style>
